//created by sudip
import { motion } from "framer-motion";
import {
    ScanSearch,
    BrainCircuit,
    Bot,
    Send,
} from "lucide-react";

interface FloatingWorkflowCardProps {
    accent: string;
}

const steps = [

    {
        icon: ScanSearch,
        label: "Capture",
    },

    {
        icon: BrainCircuit,
        label: "Analyse",
    },

    {
        icon: Bot,
        label: "Automate",
    },

    {
        icon: Send,
        label: "Deliver",
    },

];

export function FloatingWorkflowCard({

    accent,

}: FloatingWorkflowCardProps) {

    return (

        <motion.div

            animate={{
                y:[0,-8,0],
            }}

            transition={{
                duration:5,
                repeat:Infinity,
                ease:"easeInOut",
            }}

            className="
                absolute
                -left-24
                -bottom-20
                z-30
                w-52
                rounded-3xl
                border
                border-white/60
                bg-white/90
                p-5
                shadow-2xl
                backdrop-blur-xl
            "
        >

            <div className="flex items-center justify-between">

                <h4 className="text-sm font-bold text-slate-900">

                    AI Workflow

                </h4>

                <span
                    className="rounded-full px-2 py-1 text-[10px] font-semibold"
                    style={{
                        backgroundColor:`${accent}18`,
                        color:accent,
                    }}
                >

                    ACTIVE

                </span>

            </div>

            <div className="mt-5 space-y-3">

                {steps.map((step)=>{

                    const Icon=step.icon;

                    return(

                        <div
                            key={step.label}
                            className="
                                flex
                                items-center
                                gap-3
                            "
                        >

                            <div
                                className="
                                    flex
                                    h-9
                                    w-9
                                    items-center
                                    justify-center
                                    rounded-xl
                                "
                                style={{
                                    backgroundColor:`${accent}15`,
                                }}
                            >

                                <Icon
                                    className="h-4 w-4"
                                    style={{
                                        color:accent,
                                    }}
                                />

                            </div>

                            <span className="text-sm font-medium text-slate-700">

                                {step.label}

                            </span>

                        </div>

                    );

                })}

            </div>

        </motion.div>

    );

}